/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePayPeriodData
 */
export interface UpdatePayPeriodData {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePayPeriodData
     */
    confirmed?: boolean;
}

/**
 * Check if a given object implements the UpdatePayPeriodData interface.
 */
export function instanceOfUpdatePayPeriodData(value: object): value is UpdatePayPeriodData {
    return true;
}

export function UpdatePayPeriodDataFromJSON(json: any): UpdatePayPeriodData {
    return UpdatePayPeriodDataFromJSONTyped(json, false);
}

export function UpdatePayPeriodDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePayPeriodData {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmed': json['confirmed'] == null ? undefined : json['confirmed'],
    };
}

  export function UpdatePayPeriodDataToJSON(json: any): UpdatePayPeriodData {
      return UpdatePayPeriodDataToJSONTyped(json, false);
  }

  export function UpdatePayPeriodDataToJSONTyped(value?: UpdatePayPeriodData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confirmed': value['confirmed'],
    };
}

